module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('h1', [_vm._v("一稿过")]), _vm._v(" "), _c('Row', {
    staticClass: "layout-menu-row",
    attrs: {
      "type": "flex"
    }
  }, [_c('i-col', {
    staticClass: "layout-menu-left",
    attrs: {
      "span": "3"
    }
  }, [_c('div', {
    staticClass: "layout-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../static/logo.png")
    }
  })]), _vm._v(" "), _c('Menu', {
    attrs: {
      "theme": "dark",
      "width": "auto",
      "active-name": _vm.activeName,
      "open-names": ['1']
    }
  }, [_c('div', {
    staticClass: "layout-logo-left"
  }), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "1"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-navigate"
    }
  }), _vm._v("\n            导航一\n          ")], 1), _vm._v(" "), _vm._l((_vm.navList), function(item, index) {
    return _c('router-link', {
      key: "index",
      attrs: {
        "to": ("#" + (item.title))
      }
    }, [_c('Menu-item', {
      attrs: {
        "name": item.title
      },
      nativeOn: {
        "click": function($event) {
          _vm.scroll(item.title)
        }
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })], 2)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "21",
      "offset": "3"
    }
  }, [_c('first-page'), _vm._v(" "), _c('div', {
    staticClass: "layout-copy"
  }, [_vm._v("\n        2016-2017 © Roger\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-3483e7da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 27
// module chunks = 0